/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconChevronCompactDown = createReactComponent("outline", "chevron-compact-down", "IconChevronCompactDown", [["path", { "d": "M4 11l8 3l8 -3", "key": "svg-0" }]]);

export { IconChevronCompactDown as default };
//# sourceMappingURL=IconChevronCompactDown.mjs.map
